import '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-global-functions-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-store-utility/dist/es6.js';

/* eslint-disable no-unused-vars */

/* global startPrerenderCapture */

/**
 * Namespace for Breakout.
 * @constant {string}
 */
const utilityNamespace = 'breakOut';

/**
 * Constant for storing namespaced event strings.
 * @constant {object}
 */
const EVENTS = {
  BREAKOUT_INITIALIZED: `BREAKOUT_INIT.${utilityNamespace}`
};

/**
 * This utility is used to automatically trigger clicks on any element with data attribute
 * `breakout` when prerender has occurred.
 */
class BreakOut {
  /**
   * Initializes the utility.
   * @returns {void}
   */
  init() {
    document.body.setAttribute('data-detectedprerender', 'false');
    const breakoutEls = document.querySelectorAll('[data-breakout]');
    if (breakoutEls.length) {
      document.addEventListener('prerender:loadingComplete', () => {
        document.body.setAttribute('data-detectedprerender', 'true');
        for (let i = 0; i < breakoutEls.length; i += 1) {
          // Take special care not to click an accordion panel that's already open.
          const parentEl = breakoutEls[i].parentNode;
          if (!parentEl.classList.contains('accordion-panel') || !parentEl.classList.contains('active')) {
            breakoutEls[i].click();
          }
        }

        // Allow prerender snapshot to complete.
        // TODO: Determine whether this is actually doing anything.
        if (typeof startPrerenderCapture === 'function') {
          startPrerenderCapture();
        }
      });
    }
  }

  /**
   * Exposes any events for this utility.
   * @returns {object} The namespaced events object.
   */
  get EVENTS() {
    return EVENTS;
  }
}

/**
 * Single instance of `BreakOut` used to expose this utility.
 * @constant {object}
 */
var index = new BreakOut();

export { index as default };
